import { h, Component } from 'preact';
import s from 'components/bolt/salesforceSignupForm/salesforceSignupForm.sss';
import { joinClasses } from 'utils/utils';
import Store from 'store/store';
import HTML from 'components/core/html/html';
import Button from 'components/bolt/button/button';
import { navigateInternally } from 'utils/bolt';

function parse(str) {
	if (str.length) {
		return +str;
	}
	return null;
}

const pad2 = n => ('0' + n).slice(-2);

const successMessage = 'Thank you for signing up.';


export default class SalesforceSignupForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			email: '',
			day: '',
			month: '',
			year: '',
			error: ''
		};

		this.pageData = this.props.appData?.pages[this.props.id]?.data;

		this.onEmailChange = this.onEmailChange.bind(this);
		this.onReset = this.onReset.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleSubmit(e) {
		e.preventDefault();

		if (this.state.submitting) {
			return;
		}

		const { day, month, year, email } = this.state;

		const minAge = 13;
		let allowedFrom = new Date((+year) + minAge, +month, +day);
		let permitted = +allowedFrom && Date.now() >= allowedFrom;
		if (!permitted) {
			return this.setState({ error: 'invalidAge' });
		}

		return this.submitForm(email);
	}

	async submitForm(email) {
		this.setState({ submitting: true });

		const formMovieId = this.pageData?.formMovieId || this.props.appData?.meta.title.slug.replace('-', '_');
		const source = this.props.appData?.meta?.url;

		try {
			const res = await fetch('https://apps.paramountpictures.com/insider/process-subscriber.php', {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: new URLSearchParams({
					EmailAddress: email,
					PageID: formMovieId,
					Source: source
				})
			});
			const data = await res.json();
			if (data.Response !== 'Ok') {
				throw new Error('Invalid response');
			}
			Store.emit('SUBMIT_TRUE');
			this.setState({ success: true });
		} catch (e) {
			this.setState({ error: 'generalError' });
		}

		this.setState({ submitting: false });
	}

	onEmailChange(e) {
		const validEmail = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(e.target.value);

		let error = validEmail || e.target.value === '' ? '' : 'invalidEmail';
		this.setState({ email: e.target.value, error });
	}

	onReset() {
		const newState = { error: '' };
		['email', 'day', 'month', 'year'].forEach(field => newState[field] = '');

		this.setState(newState);
	}

	renderError(error) {
		const errorMessage = this.pageData?.errors[error];

		return (
			<div class={s.error}>
				{errorMessage}
			</div>
		);
	}

	renderBirthdaySelect(type, value, options) {
		return (
			<select
				id={`birthday-${type}`}
				onChange={(e) => this.setState({ [type]: parse(e.target.value) })}
				class={joinClasses(s.input, s[type], (value || value === 0) && s.valid)}
				placeholder={type}
				ref={e => this[`$${type}`] = e}
				required
			>
				<option value="">{type}</option>
				{options.map(opt => <option value={opt.value} key={opt.value}>{opt.label || opt.value}</option>)}
			</select>
		);
	}

	renderForm() {
		const appData = Store.get().appData;

		const { error, email, month, year, day, submitting } = this.state;
		const hasMonth = month || month === 0;
		const submitDisabled = (error && error !== 'generalError') || !email || !hasMonth || !year || !day;

		const movieTitleUpper = (appData.meta.title.locale || appData.meta.title.en).toUpperCase();
		let { title, legal, showResetButton } = this.pageData;
		legal = legal.replace(/%MOVIE_TITLE%/g, movieTitleUpper);
		title = title.replace(/%MOVIE_TITLE%/g, movieTitleUpper);

		let monthLabels = appData.copy?.baseCopy?.$DATETIME_LOCALE?.$MONTHS_FULL || {};

		const currentYear = new Date().getFullYear();
		const days = [...Array(31)].map((e, i) => ({ value: i + 1, label: pad2(i + 1) }));
		const months = [...Array(12)].map((e, i) => ({ value: i, label: monthLabels[i] }));
		const years = [...Array(120)].map((e, i) => ({ value: currentYear - i }));

		return [
			<div class={joinClasses(s.title, 'h4')} key="title">{title}</div>,
			<form class={joinClasses(s.form, submitting && s.submitting)} onSubmit={this.handleSubmit}>
				<div class={s.top}>
					<div class={joinClasses(s.email, email.length > 0 && s.valid, error === 'invalidEmail' && s.invalid)}>
						<label class={joinClasses(s.label, 'largeB')} for="email">Enter your email address</label>
						<input class={s.input} type="email" id="email" onInput={this.onEmailChange} placeholder="email" maxlength={128} />
					</div>
					<div class={s.birth}>
						<label class={joinClasses(s.label, 'largeB')} for="birthday-day">Enter your birth date</label>
						<div class={s.inputs}>
							{this.renderBirthdaySelect('day', day, days)}
							{this.renderBirthdaySelect('month', month, months)}
							{this.renderBirthdaySelect('year', year, years)}
						</div>
					</div>
				</div>
				<div class={joinClasses(s.legal, 'small')}>
					<HTML content={legal} markdown />
				</div>
				<div class={s.bottom}>
					{!!error && this.renderError(error)}
				</div>
				<div class={s.buttons}>
					<Button class={joinClasses(s.submit, submitDisabled && s.disabled)} type="floating" htmlType="submit">
						Submit
					</Button>
					{!!showResetButton && (
						<Button class={joinClasses(s.cancel)} type="floating" htmlType="reset" trigger={this.onReset}>
							Cancel
						</Button>
					)}
				</div>
			</form>
		];
	}

	renderSuccess() {
		let { successButton } = this.pageData;
		return (
			<div class={s.success} key="success">
				<div class={joinClasses(s.successMessage, 'xlargeB')}>
					{successMessage}
				</div>
				<Button
					class={joinClasses(s.submit)}
					trigger={() => navigateInternally('boltHome')}
					type="floating"
				>
					{successButton}
				</Button>
			</div>
		);
	}

	render(props, state) {
		const { success } = state;

		const content = success ? this.renderSuccess() : this.renderForm();
		return (
			<div class={joinClasses('frameBuster', s.wrapper)}>
				{content}
			</div>
		);
	}
}